import * as React from "react";

function ChartNetworkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M288 64c0 16.85-6.5 32.18-17.2 43.6l26.9 57.6c12.2-3.4 25-5.2 38.3-5.2 38.1 0 74.4 15.5 100.3 40.7l77.6-57c-1.2-5-1.9-10.3-1.9-15.7 0-35.35 28.7-64 64-64s64 28.65 64 64c0 35.3-28.7 64-64 64-12.3 0-23.9-3.5-33.7-9.6l-77.6 57c9.8 19.4 15.3 41.4 15.3 64.6 0 18.5-3.5 36.2-9.9 52.5l67.4 40.4c10.7-8.1 24-12.9 38.5-12.9 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64c0-3.4.3-6.7.8-9.9l-67.4-40.5C418.1 428.5 379.8 448 336 448c-71.4 0-130.6-51.9-142.9-120h-69.8c-9.4 23.5-32.44 40-59.3 40-35.35 0-64-28.7-64-64s28.65-64 64-64c26.86 0 49.9 16.5 59.3 40h69.8c7.5-39.1 29.8-72.9 61.1-94.5l-26.9-57.6c-1.1-.8-2.2.1-3.3.1-35.3 0-64-28.65-64-64s28.7-64 64-64 64 28.65 64 64zm48 336c53 0 96-43 96-96 0-53.9-43-96-96-96-53.9 0-96 42.1-96 96 0 53 42.1 96 96 96z"
  }));
}

const ForwardRef = React.forwardRef(ChartNetworkIcon);
export default ForwardRef;